import React from 'react';
import { Section, Reveal } from './Section';
import { CtaButton } from './CtaButton';
export function FinalCta() {
  return <Section className="relative overflow-hidden bg-ink-950 bg-grid text-center" data-id="element-75" data-mp="vghi7rluohq2">
      <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-1/2 h-[360px] w-[640px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-brand/10 blur-[120px]" data-id="element-76" data-mp="19f7ej50uiddd" />
      <Reveal className="relative" data-id="element-77" data-mp="1jcv83rmptety">
        <h2 className="mx-auto max-w-2xl font-display text-2xl font-extrabold leading-tight tracking-tight text-white sm:text-3xl lg:text-4xl" data-id="element-78" data-mp="1jbtx1n5p8sc8">
          Empezá a invertir con método, no con humo.
        </h2>
        <div className="mt-8 flex flex-col items-center" data-id="element-79" data-mp="1t2ewtdx402wq">
          <CtaButton size="lg" className="w-full max-w-md" data-id="element-80" data-mp="1o3bqzr9b1snp">
            QUIERO MI ACCESO — $27.990
          </CtaButton>
          <p className="mt-4 text-xs text-gray-500 sm:text-sm" data-id="element-81" data-mp="224o13m1sb01o">
            🔒 Pago 100% seguro · ⚡ Acceso inmediato · 🛡️ Garantía 30 días
          </p>
        </div>
      </Reveal>
    </Section>;
}